import { ref, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';
import { t } from '@/utils/i18n-helper';

/**
 * Gestiona la carga de info de pago y datos de tarjeta guardada.
 */
export function usePaymentMethodInfo() {
    const tarjetaGuardada = ref(null);
    const jetId = ref(null);
    const cargandoInfoPago = ref(false);

    const tarjetaLast4 = computed(() => {
        const pan = tarjetaGuardada.value?.panVuePayCard || tarjetaGuardada.value?.pan || '';
        return pan.replace(/\s/g, '').slice(-4);
    });

    const tid = computed(() => store.getters.getConfig?.hash_teatro || '');

    const cargarInfoPago = async onError => {
        if (cargandoInfoPago.value) return;
        cargandoInfoPago.value = true;
        try {
            const base = { tid: tid.value, filters: {} };
            const [infoRes, jetRes] = await Promise.all([
                store.dispatch(config.getVuexAlias('front.perfil.info_pago'), { tid: tid.value, filters: {} }),
                store.dispatch(config.getVuexAlias('front.perfil.get-jet-id'), base),
            ]);

            jetId.value = jetRes.data.jet_id;

            if (infoRes.data?.pan && !infoRes.data?.error) {
                tarjetaGuardada.value = {
                    titular: infoRes.data.titular,
                    panVuePayCard: infoRes.data.panVuePayCard || infoRes.data.pan,
                    pan: infoRes.data.pan,
                    mesCaducidad: infoRes.data.mesCaducidad,
                    anoCaducidad: infoRes.data.anoCaducidad,
                };
                return 'guardada';
            }
            return 'nueva';
        } catch (e) {
            onError?.(t('perfil.error_cargar_info_pago', {}, 'Error al cargar informacion de pago'));
            return null;
        } finally {
            cargandoInfoPago.value = false;
        }
    };

    const resetPaymentInfo = () => {
        tarjetaGuardada.value = null;
        jetId.value = null;
        cargandoInfoPago.value = false;
    };

    return {
        tarjetaGuardada,
        tarjetaLast4,
        jetId,
        cargandoInfoPago,
        tid,
        cargarInfoPago,
        resetPaymentInfo,
    };
}
